import "./InfoAside.scss";
function InfoAside() {
	return (
		<section className="info_aside">
			<div>
				<p>foofest@festival.dk</p>
				<p>+45 66660000</p>
			</div>
		</section>
	);
}

export default InfoAside;
